export default "__VITE_ASSET__DRTXycwA__"